import React from 'react';

const JoinRequestsButtons = ({ data, acceptDecline }) => {
    return (
        <div className="joinRequestsButtons">
            <button className="joinRequestsButton joinRequestsDecline" onClick={() => acceptDecline(data.accountId, false)} />
            <button className="joinRequestsButton joinRequestsAccept" onClick={() => acceptDecline(data.accountId, true)} />
        </div>
    );
};

export default JoinRequestsButtons;
